webpackJsonp([228497914701036],{

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _addClass = __webpack_require__(231);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(232);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(93);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _PropTypes = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	var removeClass = function removeClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass2.default)(node, c);
	  });
	};
	
	var propTypes = _extends({}, _Transition2.default.propTypes, {
	
	  /**
	   * The animation classNames applied to the component as it enters or exits.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   * }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	});
	
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 *
	 * ```js
	 * import CSSTransition from 'react-transition-group/CSSTransition';
	 *
	 * const Fade = ({ children, ...props }) => (
	 *  <CSSTransition
	 *    {...props}
	 *    timeout={500}
	 *    classNames="fade"
	 *  >
	 *   {children}
	 *  </CSSTransition>
	 * );
	 *
	 * class FadeInAndOut extends React.Component {
	 *   constructor(...args) {
	 *     super(...args);
	 *     this.state= { show: false }
	 *
	 *     setInterval(() => {
	 *       this.setState({ show: !this.state.show })
	 *     }, 5000)
	 *   }
	 *   render() {
	 *     return (
	 *       <Fade in={this.state.show}>
	 *         <div>Hello world</div>
	 *       </Fade>
	 *     )
	 *   }
	 * }
	 * ```
	 *
	 * And the coorresponding CSS for the `<Fade>` component:
	 *
	 * ```css
	 * .fade-enter {
	 *   opacity: 0.01;
	 * }
	 *
	 * .fade-enter.fade-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 500ms ease-in;
	 * }
	 *
	 * .fade-exit {
	 *   opacity: 1;
	 * }
	 *
	 * .fade-exit.fade-exit-active {
	 *   opacity: 0.01;
	 *   transition: opacity 300ms ease-in;
	 * }
	 * ```
	 */
	
	var CSSTransition = function (_React$Component) {
	  _inherits(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.onEntered = function (node, appearing) {
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	      _this.removeClasses(node, 'enter');
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	
	
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	
	      return { className: className, activeClassName: activeClassName };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
	    var _getClassNames = this.getClassNames(type),
	        className = _getClassNames.className,
	        activeClassName = _getClassNames.activeClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	  };
	
	  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    /* eslint-disable no-unused-expressions */
	    node.scrollTop;
	    /* eslint-enable no-unused-expressions */
	    addClass(node, className);
	  };
	
	  CSSTransition.prototype.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	
	    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react2.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransition;
	module.exports = exports['default'];

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disabled appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disabled enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disabled exit animations
	    * for all children. Note that specifying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ```jsx
	 * import TransitionGroup from 'react-transition-group/TransitionGroup';
	 *
	 * class TodoList extends React.Component {
	 *   constructor(props) {
	 *     super(props)
	 *     this.state = {items: ['hello', 'world', 'click', 'me']}
	 *   }
	 *   handleAdd() {
	 *     const newItems = this.state.items.concat([
	 *       prompt('Enter some text')
	 *     ]);
	 *     this.setState({ items: newItems });
	 *   }
	 *   handleRemove(i) {
	 *     let newItems = this.state.items.slice();
	 *     newItems.splice(i, 1);
	 *     this.setState({items: newItems});
	 *   }
	 *   render() {
	 *     return (
	 *       <div>
	 *         <button onClick={() => this.handleAdd()}>Add Item</button>
	 *         <TransitionGroup>
	 *           {this.state.items.map((item, i) => (
	 *             <FadeTransition key={item}>
	 *               <div>
	 *                 {item}{' '}
	 *                 <button onClick={() => this.handleRemove(i)}>
	 *                   remove
	 *                 </button>
	 *               </div>
	 *             </FadeTransition>
	 *           ))}
	 *         </TransitionGroup>
	 *       </div>
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleExited = function (key, node, originalHandler) {
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (key in currentChildMapping) return;
	
	      if (originalHandler) originalHandler(node);
	
	      _this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[key];
	        return { children: children };
	      });
	    };
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        var onExited = function onExited(node) {
	          _this.handleExited(child.key, node, child.props.onExited);
	        };
	
	        return (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var onExited = function onExited(node) {
	        _this2.handleExited(child.key, node, child.props.onExited);
	      };
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: onExited,
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = this.state.children;
	
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    return _react2.default.createElement(
	      Component,
	      props,
	      values(children).map(childFactory)
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransition = __webpack_require__(195);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _TransitionGroup = __webpack_require__(196);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _Transition = __webpack_require__(93);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition2.default,
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransition: _CSSTransition2.default
	};

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	"use strict";
	/** PYTANIA DO FAQ */
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ZAKLADANIE_SPOLEK_PAGE_FAQ_QUESTIONS = [{
	    elementQuestion: "1. Ile trwa założenie spółki zoo?",
	    elementAnswer: "W zależności od regionu Polski, procedura założenia spółki w systemie S24 od jej rozpoczęcia do momentu wpisu w KRS trwa zazwyczaj od 6 do 10 dni roboczych."
	}, {
	    elementQuestion: "2. Czy można otrzymać fakturę za usługę założenia spółki zoo?",
	    elementAnswer: "Tak, za przeprowadzenie rejestracji spółki otrzymują Państwo fakturę VAT."
	}, {
	    elementQuestion: "3. Czy otrzymaną fakturę można wliczyć w koszty?",
	    elementAnswer: "Tak, otrzymaną fakturę można wliczyć w koszty uzyskania przychodu."
	}, {
	    elementQuestion: "4. Kto może być udziałowcem w firmie?",
	    elementAnswer: ["W przypadku mikro sp. z o.o., patrząc z perspektywy uproszczeń rozliczeniowych i podatkowych, najkorzystniejszym przypadkiem jest gdy udziałowcem jest osoba fizyczna.", "Więcej informacji można odleźć również dziale II pkt 1 wpisu na naszej bazie wiedzy."],
	    elementButtonLinkTo: "https://pomoc.fakturomania.pl/support/solutions/articles/36000307874-czym-jest-sp-z-o-o-oraz-jak-j%C4%85-zorganizowa%C4%87-informacje-og%C3%B3lne"
	}, {
	    elementQuestion: "5. Co z ZUS?",
	    elementAnswer: "Wspólnicy spółki z o.o., której struktura właścicielska jest dwu lub ponad dwuosobowa, nie podlegają ZUS. Dany stan rzeczy wynika z braku objęcia obowiązkiem ZUS wspólników w art. 8 ust. 6 ustawy o systemie ubezpieczeń społecznych."
	}, {
	    elementQuestion: "6. Gdzie może być siedziba firmy?",
	    elementAnswer: "Siedzibą spółki jest miejscowość. Siedziba spółki może znajdować się w miejscu  zamieszkania - w domu, w lokalu w mieszkaniu, ale też w przestrzeniach wynajmowanych."
	}, {
	    elementQuestion: "7. Jakie są obowiązki związane z rejestracją spółki z o.o.??",
	    elementAnswer: ["Wraz z rejestracją podmiotu niezbędne jest przygotowanie dokumentacji składanej do Urzędu Skarbowego. Co do zasady są to następujące dokumenty: NIP-8, PCC-3 oraz ewentualnie VAT-R w przypadku rejestracji podmiotu w rejestrze VAT jako \"czynny podatnik VAT\" albo dla celów VATu europejskiego. ", "Niezbędne jest również przygotowanie umowy najmu lokalu oraz zgłoszenie spółki do CRBR."],
	    elementButtonLinkTo: "https://pomoc.fakturomania.pl/support/solutions/articles/36000278880-najem-lokalu-dla-sp%C3%B3%C5%82ki-z-o-o-"
	}];
	exports.CENNIK_PAGE_FAQ_QUESTIONS = [{
	    elementQuestion: "1. Czy możliwe jest przetestowanie aplikacji przed wykupieniem płatnego pakietu?",
	    elementAnswer: "Tak, każdy Użytkownik może skorzystać z bezpłatnego miesięcznego okresu testowego. Oznacza to, że przez miesiąc Użytkownik może bezpłatnie korzystać z pełnej funkcjonalności aplikacji."
	}, {
	    elementQuestion: "2. Co się dzieje po wygaśnięciu okresu testowego?",
	    elementAnswer: "Po wygaśnięciu okresu testowego konto przechodzi w stan spoczynku. Oznacza to, że jego funkcjonalność zostaje zredukowana jedynie do bezpłatnej funkcjonalności, którą jest wystawianie faktur sprzedażowych."
	}, {
	    elementQuestion: "3. Czy płatny pakiet umożliwia samodzielne prowadzenie pełnej księgowości online?",
	    elementAnswer: ["Tak, każdy pakiet premium wystarcza do prowadzenia pełnej księgowości online mikro sp. z o.o. Niniejsze narzędzie umożliwia bardzo łatwe rozliczenie niewielkich podmiotów sp. z o.o. których działąlność występuje na terytorium Rzeczypospolitej o charakterze usługowym lub handlowym", "Ponad 95% Podatników prowadzących swoje rozliczenie w księgowości Fakturomanii to mali podatnicy, których statystyczne rozliczenie oscyluje w granicach do 30 dokumentów w ujęciu miesięcznym. Z tego względu księgowość z Fakturomanią jest optymalizowana właśnie pod kątem takiej wielkości działalności, tak aby każdy mógł w sposób przystępny i prosty rozliczyć taką mikro sp. z o.o.", "System nie jest jednak odpowiedni dla działalności o charakterze produkcyjnym, deweloperskim, transgranicznym lub inwestycyjnym. Z uwagi też na dedykację dla podstawowego obrotu krajowego, w systemie nie są wspierane transakcje o charakterze walutowym lub przynależnym do zysków kapitałowych (np. inwestycje w obrót kryptowalutami, papierami wartościowymi, akcjami, udziałami, zyskami z osób prawnych - przychodów, o których mowa m.in. w art. 7b ustwawy z dnia 15 lutego 1992 o podatku dochodowym od osób prawnych).", "System nie jest również odpowiedni dla podmiotów, które posiadają udziały w innych osobach prawnych lub wspólnikami są osoby prawne, lub w których występują transakcje transgraniczne w tym podlegające procedurze OSS lub IOSS za wyjątkiem sporadycznych transakcji zakupowych WNT lub importu usług. Taki typ działalności warto jest powierzyć prowadzeniu przez biuro rachunkowe z uwagi na jego znaczne skomplikowanie."]
	}, {
	    elementQuestion: "4. Co się dzieje po wygaśnięciu pakietu płatnego?",
	    elementAnswer: "Po wygaśnięciu pakietu płatnego funkcjonalność konta zostaje ograniczona do przeglądania wygenerowanych uprzednio dokumentów oraz konto zamienia się w konto dla bezpłatnej funcjonalności."
	}, {
	    elementQuestion: "5. Czy dla Użytkownika jest możliwość uzyskania pomocy księgowego?",
	    elementAnswer: "W przypadku zdecydowania się na korzystanie z Fakturomanii, w godzinach od 10 do 16, w przypadku pytań lub wątpliwości nasi księgowi są do Państwa dyspozycji. Jeżeli zatem pojawiają się pytania dotyczące aplikacji, księgowości lub spółek zoo - zachęcamy do kontaktu przez czat, mailowo lub telefonicznie, zawsze udzielamy Państwu wsparcia."
	}, {
	    elementQuestion: "6. Czy dostęp do doradcy księgowego zawiera się w pakiecie bezpłatnym?",
	    elementAnswer: "W przypadku pakietu bezpłatnego zespół wsparcia Fakturomanii zawsze udzieli Państwu pomocy z zakresu obsługi technicznej aplikacji."
	}, {
	    elementQuestion: "7. Czy jeśli wykupię dostęp do aplikacji, będę związany umową na czas określony? Czy są jakieś kary umowne lub odsetki?",
	    elementAnswer: "Wykupienie dostępu do aplikacji skutkuje zawiązaniem umowy drogą elektroniczną na czas oznaczony odpowiadający wybranemu pakietowi. Brak jest kar umownych lub odsetek, w każdej chwili mogą Państwo zrezygnować z usług serwisu Fakturomania. W przypadku rezygnacji z serwisu kwota za niewykorzystany czas abonamentu nie podlega jednak zwrotowi."
	}, {
	    elementQuestion: "8. Czy aplikacja Fakturomanii jest skierowana do działalności gospodarczej osób fizycznych?",
	    elementAnswer: ["Aplikacja Fakturomanii jest dedykowana wyłącznie dla osób prawnych - mikro sp. z o.o."]
	}];
	exports.FAQ_PAGE_FAQ_QUESTIONS = [{
	    elementQuestion: "1. Czym jest Fakturomania?",
	    elementAnswer: ["Fakturomania to aplikacja webowa służąca prowadzeniu pełnej księgowości online.", "Nasze rozwiązanie skierowane jest do mikro spółek z ograniczoną odpowiedzialnością prowadzących działalność gospodarczą na terytorium Polski.", "Jeśli chcesz prowadzić własną firmę, ale obawiasz się wysokich kosztów związanych z jej prowadzeniem – Fakturomania może być dobrym rozwiązaniem."]
	}, {
	    elementQuestion: "2. Czym jest pełna księgowość online?",
	    elementAnswer: "Pełna księgowość to rozbudowany, precyzyjny i dokładny system ewidencji zdarzeń gospodarczych, będący częścią Rachunkowości. Służy on do kontroli, analizy i generowania informacji na temat sytuacji firmy w danym momencie lub na przestrzeni pewnego okresu."
	}, {
	    elementQuestion: "3. Czy Fakturomania wymaga specjalistycznej wiedzy księgowej?",
	    elementAnswer: ["Nie, rozliczenia w Fakturomanii nie wymagają posiadania specjalistycznej wiedzy księgowej. Do korzystania z aplikacji wystarczy połączenie z internetem, przeglądarka internetowa, systematyczność oraz skrupulatność.", "Obsługa aplikacji została na tyle uproszczona, aby każdy był w stanie poprowadzić pełną księgowość mikro spółek zoo. W razie jakichkolwiek wątpliwości zawsze służymy pomocą.", "Fakturomania to również bogata baza wiedzy omawiająca zagadnienia związane z księgowością, podatkami i samą spółką z o.o."]
	}, {
	    elementQuestion: "4. Dla kogo przeznaczona jest aplikacja?",
	    elementAnswer: "Aplikacja jest dedykowana jednostkom mikro, które prowadzą działalność w formie spółki z o.o. o profilu usługowym, handlowym lub usługowo-handlowym na terytorium Polski."
	}, {
	    elementQuestion: "5. Ile można zyskać, prowadząc firmę w formie spółki z o.o.?",
	    elementAnswer: ["Dzięki spółce z o.o. zyskać można bardzo wiele, zarówno pod względem znaczącego ograniczenia odpowiedzialności jak i też pod względem oszczędności.", "Kwota oszczędności wynosić może od kilku do nawet kilkudziesięciu tysięcy złotych rocznie - w przypadku optymalnego zaplanowania działaności."]
	}, {
	    elementQuestion: "6. Co z ZUS?",
	    elementAnswer: "W sytuacji gdy wspólników w spółce jest co najmniej dwóch, to żaden z nich nie podlega obowiązkowi ubezpieczeń społecznych oraz zdrowotnych. Decyzja o dobrowolnym ubezpieczeniu należy do przedsiębiorcy."
	}, {
	    elementQuestion: "7. Co z polityką rachunkowości oraz planem kont?",
	    elementAnswer: "Dla Państwa wygody przygotowany został uniwersalny plan kont oraz polityka rachunkowości, które są generowane automatycznie przez aplikację. Dokumenty te wystarczy wydrukować i podpisać."
	}];

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var companyData = __webpack_require__(41);
	/** DANE DO FORMULARZY */
	exports.KontaktPageFormInfo = {
	    iconClassName: "mail",
	    titleFirstLine: "Masz pytania?",
	    titleSecondLine: "Zostaw wiadomość!",
	    descriptionFirstLine: "Wyślij wiadomość poprzez formularz,",
	    descriptionSecondLine: "a skontaktujemy się z",
	    descriptionSecondLineBlueWord: "Tobą."
	};
	exports.KontaktPageInitialFormData = [{
	    fieldOrdinal: 1,
	    fieldLabel: "Imię i nazwisko",
	    fieldName: "name",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 2,
	    fieldLabel: "Email",
	    fieldName: "email",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 3,
	    fieldLabel: "Firma",
	    fieldName: "company",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 4,
	    fieldLabel: "Temat",
	    fieldName: "subject",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 5,
	    fieldLabel: "Wiadomość",
	    fieldName: "message",
	    fieldValue: "",
	    fieldType: "textarea"
	}];
	exports.BiuroRachunkowePageFormInfo = {
	    iconClassName: "phone-outline",
	    titleFirstLine: "Zadzwoń do nas!",
	    titleSecondLine: companyData.FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_PHONE,
	    descriptionFirstLine: "Możesz również skontaktować się",
	    descriptionSecondLine: "poprzez ",
	    descriptionSecondLineBlueWord: "formularz kontaktowy."
	};
	exports.BiuroRachunkowePageInitialFormData = [{
	    fieldOrdinal: 1,
	    fieldLabel: "Imię i nazwisko",
	    fieldName: "name",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 2,
	    fieldLabel: "Email",
	    fieldName: "email",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 3,
	    fieldLabel: "Firma",
	    fieldName: "company",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 4,
	    fieldLabel: "Temat",
	    fieldName: "subject",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 5,
	    fieldLabel: "Wiadomość",
	    fieldName: "message",
	    fieldValue: "",
	    fieldType: "textarea"
	}];
	exports.ZakladanieSpolekZooPageFormInfo = {
	    iconClassName: "phone-outline",
	    titleFirstLine: "Zadzwoń do nas!",
	    titleSecondLine: companyData.FAKTUROMANIA_ACCOUNTING_OFFICE_COMPANY_PHONE,
	    descriptionFirstLine: "Możesz również skontaktować się",
	    descriptionSecondLine: "poprzez ",
	    descriptionSecondLineBlueWord: "formularz kontaktowy."
	};
	exports.ZakladanieSpolekZooPageInitialFormData = [{
	    fieldOrdinal: 1,
	    fieldLabel: "Imię i nazwisko",
	    fieldName: "name",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 2,
	    fieldLabel: "Email",
	    fieldName: "email",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 3,
	    fieldLabel: "Firma",
	    fieldName: "company",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 4,
	    fieldLabel: "Temat",
	    fieldName: "subject",
	    fieldValue: "",
	    fieldType: "text-field"
	}, {
	    fieldOrdinal: 5,
	    fieldLabel: "Wiadomość",
	    fieldName: "message",
	    fieldValue: "",
	    fieldType: "textarea"
	}];
	/** VALIDATIONS */
	exports.EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var freshworks_1 = __webpack_require__(77);
	var FRESHDESK_SUPPORT_WIDGET_IFRAME_SOURCE_URL_PREFIX = 'https://fakturomania.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&widgetView=no&searchArea=no';
	var FORM_TITLE_PREFIX = 'formTitle=FORMULARZ KONTAKTOWY';
	var SUBMIT_BUTTON_NAME_PREFIX = 'submitTitle=Wyślij';
	var SUBMIT_MESSAGE_PREFIX = 'submitThanks=Dziękujemy za przesłanie zgłoszenia!';
	exports.BIURO_RACHUNKOWE_PAGE_FORM_IFRAME_SOURCE_URL = prepareIframeSourceUrl(freshworks_1.TicketSource.BiuroRachunkowe);
	exports.ZAKLADANIE_SPOLEK_PAGE_FORM_IFRAME_SOURCE_URL = prepareIframeSourceUrl(freshworks_1.TicketSource.ZakladanieSpolek);
	exports.KONTAKT_PAGE_FORM_IFRAME_SOURCE_URL = prepareIframeSourceUrl(freshworks_1.TicketSource.Kontakt);
	/** FUNKCJE POMOCNICZE */
	function prepareIframeSourceUrl(formSource) {
	    // DANE UNIVERSALNE
	    var ID_FIRMA_SRC_PART = prepareFieldFormQueryString('cf_companyid_817316', 0, true);
	    var ZRODLO_SRC_PART = prepareFieldFormQueryString('cf_zrodlo_817316', formSource, true);
	    // ŁĄCZENIE PARTÓW
	    var widgedSourceSrcList = [FRESHDESK_SUPPORT_WIDGET_IFRAME_SOURCE_URL_PREFIX, FORM_TITLE_PREFIX, SUBMIT_BUTTON_NAME_PREFIX, SUBMIT_MESSAGE_PREFIX, ID_FIRMA_SRC_PART, ZRODLO_SRC_PART];
	    // SKŁADANIE URL
	    return widgedSourceSrcList.join('&');
	}
	function prepareFieldFormQueryString(fieldName, fieldValue, disabled) {
	    // JEZELI NIE JEST ZABLOKOWANE
	    if (!disabled) {
	        return "helpdesk_ticket[custom_field][" + fieldName + "]=" + fieldValue;
	    } else {
	        return "helpdesk_ticket[custom_field][" + fieldName + "]=" + fieldValue + "&disable[custom_field][" + fieldName + "]=true";
	    }
	}

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_transition_group_1 = __webpack_require__(197);
	var FadingElement = function FadingElement(props) {
	    return React.createElement(react_transition_group_1.Transition, { in: props.in, timeout: 150 }, function (state) {
	        return React.createElement("div", { style: _extends({}, DefaultStyle, TransitionStyles[state]) }, props.children);
	    });
	};
	/** STYLES */
	var DefaultStyle = {
	    transition: "opacity .15s linear",
	    opacity: 0,
	    display: 'none'
	};
	var TransitionStyles = {
	    entering: {
	        opacity: 0,
	        display: 'none'
	    },
	    entered: {
	        opacity: 1,
	        display: 'block'
	    }
	};
	exports.default = FadingElement;

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-around;\n  @media (min-width : 993px) {\n    padding-right: 40px;\n    padding-left: 40px;\n    margin-top: 100px;\n  }\n"], ["\n  display: flex;\n  justify-content: space-around;\n  @media (min-width : 993px) {\n    padding-right: 40px;\n    padding-left: 40px;\n    margin-top: 100px;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  max-width: 1200px;\n  width: 100%;\n  justify-content: space-around;\n    @media (max-width : 993px) {\n      flex-direction: column;\n      padding-right: 40px;\n      padding-left: 40px;\n    }\n  }\n"], ["\n  display: flex;\n  max-width: 1200px;\n  width: 100%;\n  justify-content: space-around;\n    @media (max-width : 993px) {\n      flex-direction: column;\n      padding-right: 40px;\n      padding-left: 40px;\n    }\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var contact_form_info_1 = __webpack_require__(73);
	var contact_form_1 = __webpack_require__(74);
	var styled_components_1 = __webpack_require__(2);
	var ContactFormBlock = function ContactFormBlock(props) {
	  var formInfo = props.formInfo,
	      iframeSourceUrl = props.iframeSourceUrl;
	
	  return React.createElement("div", { className: "materialize-theme-styles" }, React.createElement(ContactFormBlockWrapper, null, React.createElement(ContactFormWrapper, null, React.createElement(contact_form_info_1.default, _extends({}, formInfo)), React.createElement(contact_form_1.default, { iframeSourceUrl: iframeSourceUrl }))));
	};
	var ContactFormBlockWrapper = styled_components_1.default.div(_templateObject);
	var ContactFormWrapper = styled_components_1.default.div(_templateObject2);
	exports.default = ContactFormBlock;

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  flex-basis: 50%;\n  text-align: center;\n  @media (min-width : 993px) {\n    margin-top: 100px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-right: 30px;\n    padding-left: 30px;\n    i {\n      font-size: 160px;\n      text-align: center;\n      display: block;\n      margin-top: -100px;\n      margin-bottom: -60px;\n      color: #3190E7;\n    }\n  }\n  @media (max-width : 992px) {\n    text-align: center;\n    margin-top: 60px;\n    margin-bottom: 40px;\n    i {\n      display: none;\n    }\n  }\n"], ["\n  flex-basis: 50%;\n  text-align: center;\n  @media (min-width : 993px) {\n    margin-top: 100px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-right: 30px;\n    padding-left: 30px;\n    i {\n      font-size: 160px;\n      text-align: center;\n      display: block;\n      margin-top: -100px;\n      margin-bottom: -60px;\n      color: #3190E7;\n    }\n  }\n  @media (max-width : 992px) {\n    text-align: center;\n    margin-top: 60px;\n    margin-bottom: 40px;\n    i {\n      display: none;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: #424242 !important;\n  display: block;\n  font-size: 35px !important;\n  strong {\n    font-weight: bold;\n  }\n"], ["\n  color: #424242 !important;\n  display: block;\n  font-size: 35px !important;\n  strong {\n    font-weight: bold;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  p {\n    color: #4d4d4d;\n    margin: 0;\n    font-weight: 400 !important;\n    font-size: 18px;\n    span {\n      font-weight: bold;\n      color: #1976d2;\n    }\n  }\n"], ["\n  p {\n    color: #4d4d4d;\n    margin: 0;\n    font-weight: 400 !important;\n    font-size: 18px;\n    span {\n      font-weight: bold;\n      color: #1976d2;\n    }\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var ContactFormInfo = function ContactFormInfo(props) {
	  var iconClassName = props.iconClassName,
	      titleFirstLine = props.titleFirstLine,
	      titleSecondLine = props.titleSecondLine,
	      descriptionFirstLine = props.descriptionFirstLine,
	      descriptionSecondLine = props.descriptionSecondLine,
	      descriptionSecondLineBlueWord = props.descriptionSecondLineBlueWord;
	
	  return React.createElement(ContactFormInfoContainer, null, React.createElement("i", { className: "typcn typcn-" + iconClassName }), React.createElement(ContactFormInfoTitle, null, React.createElement("strong", null, titleFirstLine, React.createElement("br", null), titleSecondLine)), React.createElement(ContactInfoDescription, null, React.createElement("p", null, descriptionFirstLine), React.createElement("p", null, descriptionSecondLine, React.createElement("span", null, " ", descriptionSecondLineBlueWord))));
	};
	var ContactFormInfoContainer = styled_components_1.default.div(_templateObject);
	var ContactFormInfoTitle = styled_components_1.default.h3(_templateObject2);
	var ContactInfoDescription = styled_components_1.default.div(_templateObject3);
	exports.default = ContactFormInfo;

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  flex-basis: 50%;\n"], ["\n  flex-basis: 50%;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  flex-basis: 50%;\n  overflow: visible !important;\n"], ["\n  flex-basis: 50%;\n  overflow: visible !important;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  padding-bottom: 0px !important;\n"], ["\n  padding-bottom: 0px !important;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	
	var ContactForm = function (_React$Component) {
	  _inherits(ContactForm, _React$Component);
	
	  function ContactForm() {
	    _classCallCheck(this, ContactForm);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ContactForm.prototype.render = function render() {
	    var iframeSourceUrl = this.props.iframeSourceUrl;
	
	    return React.createElement(ContactFormWrapper, null, React.createElement(CardWrapper, { className: "card" }, React.createElement(IframeCardContentWrapper, { className: "card-content white-text" }, React.createElement("iframe", { title: "Feedback Form", className: "freshwidget-embedded-form", id: "freshwidget-embedded-form", src: iframeSourceUrl, scrolling: "no", height: "590px", width: "100%", frameBorder: "0" }))));
	  };
	
	  return ContactForm;
	}(React.Component);
	/** STYLES */
	/** CARD */
	
	
	var ContactFormWrapper = styled_components_1.default.div(_templateObject);
	var CardWrapper = styled_components_1.default.div(_templateObject2);
	var IframeCardContentWrapper = styled_components_1.default.div(_templateObject3);
	exports.default = ContactForm;

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-image: none !important;\n"], ["\n  background-image: none !important;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  line-height: 17.6px !important;\n"], ["\n  line-height: 17.6px !important;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n"], ["\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  margin-top: -20px;\n  padding-top: 0px !important;\n  padding-bottom: 40px !important;\n"], ["\n  margin-top: -20px;\n  padding-top: 0px !important;\n  padding-bottom: 40px !important;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"]);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var googleAnalyticsService = __webpack_require__(9);
	var styled_components_1 = __webpack_require__(2);
	var FaqBlockElement = function FaqBlockElement(props) {
	    var activeElementIndex = props.activeElementIndex,
	        elementIndex = props.elementIndex,
	        selectElement = props.selectElement,
	        elementQuestion = props.elementQuestion,
	        elementAnswer = props.elementAnswer,
	        elementButtonLinkTo = props.elementButtonLinkTo;
	
	    var isActive = activeElementIndex == elementIndex;
	    // SPRAWDZANIE CZY OPIS JEST LISTĄ
	    var elementAnswerIsAList = Array.isArray(elementAnswer);
	    // ZWRACANIE DANYCH
	    return React.createElement("div", { className: "panel panel-default" }, React.createElement(PanelHeadingWrapper, { className: "panel-heading", onClick: function onClick() {
	            return selectElement(elementIndex);
	        } }, React.createElement(PanelTitleWrapper, { className: "panel-title" }, React.createElement("a", null, elementQuestion))), React.createElement("div", { className: "panel-collapse collapse in" }, React.createElement(PanelBodyWrapper, { className: "panel-body" }, !elementAnswerIsAList && elementAnswer, elementAnswerIsAList && elementAnswer.map(function (answerPart, i) {
	        return React.createElement("div", { key: i, className: "answer-part" }, answerPart);
	    }), elementButtonLinkTo && React.createElement("a", { href: elementButtonLinkTo, target: "_blank", className: "btn btn-sm waves-effect waves-light mt-20" }, "Wi\u0119cej"))));
	};
	/** STYLES => FaqBlockElement */
	var PanelHeadingWrapper = styled_components_1.default.div(_templateObject);
	var PanelTitleWrapper = styled_components_1.default.h3(_templateObject2);
	var PanelBodyWrapper = styled_components_1.default.div(_templateObject3);
	
	var FaqBlock = function (_React$Component) {
	    _inherits(FaqBlock, _React$Component);
	
	    function FaqBlock(props) {
	        _classCallCheck(this, FaqBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            activeElementIndex: 1
	        };
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        _this.onFaqQuestionSelect = _this.onFaqQuestionSelect.bind(_this);
	        return _this;
	    }
	
	    FaqBlock.prototype.onComponentView = function onComponentView() {
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    FaqBlock.prototype.onFaqQuestionSelect = function onFaqQuestionSelect(index) {
	        // ZAZNACZANIE I ODZNACZANIE
	        var activeElementIndex = this.state.activeElementIndex;
	
	        if (index == activeElementIndex) {
	            this.setState({ activeElementIndex: 0 });
	        } else {
	            this.setState({ activeElementIndex: index });
	        }
	        // GOOGLE EVENT
	        if (this.props.faqQuestionReadEventType) {
	            googleAnalyticsService.trackEvent(this.props.faqQuestionReadEventType);
	        }
	    };
	
	    FaqBlock.prototype.render = function render() {
	        var _this2 = this;
	
	        var faqQuestions = this.props.faqQuestions;
	        var activeElementIndex = this.state.activeElementIndex;
	
	        return React.createElement("div", { className: "materialize-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(FaqBlockWrapper, { className: "section-padding" }, React.createElement("div", { className: "container" }, React.createElement(FaqBlockElementsWrapper, { className: "row" }, React.createElement("div", { className: "col-lg-9 col-md-12 col-sm-12 col-xs-12" }, React.createElement("div", { className: "panel-group flat-accordion brand-accordion z-depth-1" }, faqQuestions.map(function (faqQuestion, index) {
	            return React.createElement(FaqBlockElement, _extends({ key: index, activeElementIndex: activeElementIndex, elementIndex: index + 1, selectElement: _this2.onFaqQuestionSelect }, faqQuestion));
	        })))))));
	    };
	
	    return FaqBlock;
	}(React.Component);
	/** STYLES => FaqBlock */
	
	
	var FaqBlockWrapper = styled_components_1.default.section(_templateObject4);
	var FaqBlockElementsWrapper = styled_components_1.default.div(_templateObject5);
	exports.default = FaqBlock;

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-image: \n    linear-gradient(\n      rgba(0, 0, 0, 0.3), \n      rgba(0, 0, 0, 0.3)\n    ),\n    url(", ");\n  background-size: cover !important;\n  background-attachment: inherit !important;\n  height: 600px !important;\n"], ["\n  background-image: \n    linear-gradient(\n      rgba(0, 0, 0, 0.3), \n      rgba(0, 0, 0, 0.3)\n    ),\n    url(", ");\n  background-size: cover !important;\n  background-attachment: inherit !important;\n  height: 600px !important;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: white;\n  text-transform: initial !important;\n"], ["\n  color: white;\n  text-transform: initial !important;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: white;\n  font-weight: 600;\n  margin-bottom: 0px !important;\n"], ["\n  color: white;\n  font-weight: 600;\n  margin-bottom: 0px !important;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var googleAnalyticsService = __webpack_require__(9);
	
	var HeroTextOnLeftBlock = function (_React$Component) {
	    _inherits(HeroTextOnLeftBlock, _React$Component);
	
	    function HeroTextOnLeftBlock(props) {
	        _classCallCheck(this, HeroTextOnLeftBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        return _this;
	    }
	
	    HeroTextOnLeftBlock.prototype.onComponentView = function onComponentView() {
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    HeroTextOnLeftBlock.prototype.render = function render() {
	        var _props = this.props,
	            title = _props.title,
	            description = _props.description,
	            backgroundImage = _props.backgroundImage;
	
	        return React.createElement("div", { className: "materialize-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(HeroBlockWrapper, { className: "parallax-bg valign-wrapper", backgroundImage: backgroundImage }, React.createElement("div", { className: "valign-cell" }, React.createElement("div", { className: "container" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-md-6" }, React.createElement(HeroBlockTitleWrapper, { className: "intro-title text-capitalize" }, title), description.map(function (text, index) {
	            return React.createElement(HeroBlockTitleDescriptionWrapper, { className: "lead", key: index }, text, React.createElement("br", null));
	        })))))));
	    };
	
	    return HeroTextOnLeftBlock;
	}(React.Component);
	/** STYLES */
	
	
	var HeroBlockWrapper = styled_components_1.default.section(_templateObject, function (props) {
	    return props.backgroundImage;
	});
	var HeroBlockTitleWrapper = styled_components_1.default.h1(_templateObject2);
	var HeroBlockTitleDescriptionWrapper = styled_components_1.default.h1(_templateObject3);
	exports.default = HeroTextOnLeftBlock;

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  .active:after {\n    border-top-color: #03a9f4 !important;\n  }\n"], ["\n  .active:after {\n    border-top-color: #03a9f4 !important;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  @media (min-width : 993px) {\n    height: 330px;\n  }\n  @media (max-width : 800px) {\n    height: 380px;\n  }\n  @media (max-width : 600px) {\n    height: 450px;\n  }\n  @media (max-width : 550px) {\n    height: 500px;\n  }\n  @media (max-width : 550px) {\n    height: 600px;\n  }\n"], ["\n  @media (min-width : 993px) {\n    height: 330px;\n  }\n  @media (max-width : 800px) {\n    height: 380px;\n  }\n  @media (max-width : 600px) {\n    height: 450px;\n  }\n  @media (max-width : 550px) {\n    height: 500px;\n  }\n  @media (max-width : 550px) {\n    height: 600px;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', sans-serif !important;\n  font-size: 20px !important;\n  min-width: 0 !important;\n  border-radius: 15% !important;\n  padding-top: 0px !important;\n  &[data-tab-is-active~=\"true\"] {\n    color: #03a9f4 !important;\n  }  \n  &[data-tab-is-active~=\"false\"] {\n    background: #03a9f4 !important;\n    color: white;\n  }\n  float: none !important;\n"], ["\n  font-family: 'Roboto', sans-serif !important;\n  font-size: 20px !important;\n  min-width: 0 !important;\n  border-radius: 15% !important;\n  padding-top: 0px !important;\n  &[data-tab-is-active~=\"true\"] {\n    color: #03a9f4 !important;\n  }  \n  &[data-tab-is-active~=\"false\"] {\n    background: #03a9f4 !important;\n    color: white;\n  }\n  float: none !important;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-weight: bold !important;\n  :hover {\n    background: #03a9f4 !important;\n    span {\n      background: white !important;\n      color: #03a9f4 !important;\n    }\n  }\n  &[data-tab-is-active~=\"true\"] {\n    background: #03a9f4 !important;\n  }\n"], ["\n  font-weight: bold !important;\n  :hover {\n    background: #03a9f4 !important;\n    span {\n      background: white !important;\n      color: #03a9f4 !important;\n    }\n  }\n  &[data-tab-is-active~=\"true\"] {\n    background: #03a9f4 !important;\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var fading_element_1 = __webpack_require__(98);
	var styled_components_1 = __webpack_require__(2);
	var googleAnalyticsService = __webpack_require__(9);
	var IntroStepSelectBlockElementSelector = function IntroStepSelectBlockElementSelector(props) {
	  var activeElementOrdinal = props.activeElementOrdinal,
	      elementOrdinal = props.elementOrdinal,
	      selectElement = props.selectElement,
	      elementSelectorTitle = props.elementSelectorTitle;
	
	  var elementIsActive = activeElementOrdinal == elementOrdinal;
	  return React.createElement("li", { className: elementIsActive ? "active" : "", onClick: function onClick() {
	      return selectElement(elementOrdinal);
	    } }, React.createElement(StyledLink, { "data-tab-is-active": elementIsActive }, React.createElement(StyledSpan, { className: "badge", "data-tab-is-active": elementIsActive }, elementOrdinal), elementSelectorTitle));
	};
	
	var IntroStepSelectBlock = function (_React$Component) {
	  _inherits(IntroStepSelectBlock, _React$Component);
	
	  function IntroStepSelectBlock(props) {
	    _classCallCheck(this, IntroStepSelectBlock);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      activeTabIndex: 1
	    };
	    _this.onComponentView = _this.onComponentView.bind(_this);
	    _this.onElementSelect = _this.onElementSelect.bind(_this);
	    return _this;
	  }
	
	  IntroStepSelectBlock.prototype.onComponentView = function onComponentView() {
	    if (this.props.componentViewEventType) {
	      googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	    }
	  };
	
	  IntroStepSelectBlock.prototype.onElementSelect = function onElementSelect(elementOrdinal) {
	    // SELECTING ELEMENT
	    this.setState({ activeTabIndex: elementOrdinal });
	    // GOOGLE EVENT
	    if (this.props.elementSelectEventType) {
	      googleAnalyticsService.trackEvent(this.props.elementSelectEventType);
	    }
	  };
	
	  IntroStepSelectBlock.prototype.renderElementDescription = function renderElementDescription(elementDescription) {
	    // SPRAWDZANIE CZY ELEMENT DESCRIPTION JEST LISTĄ
	    var elementDescriptionIsArray = Array.isArray(elementDescription);
	    // ZWRACANIE DANYCH
	    return React.createElement("div", null, !elementDescriptionIsArray && React.createElement("p", null, elementDescription), elementDescriptionIsArray && elementDescription.map(function (elementDescriptionPart, i) {
	      return React.createElement("p", { key: i }, elementDescriptionPart);
	    }));
	  };
	
	  IntroStepSelectBlock.prototype.render = function render() {
	    var _this2 = this;
	
	    var stepSelectElements = this.props.stepSelectElements;
	    var activeTabIndex = this.state.activeTabIndex;
	
	    return React.createElement("div", { className: "goodgrowth-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(IntroStepSelectBlockWrapper, { className: "content" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-sm-12" }, React.createElement("div", { className: "tabbable bigtabs tabs-top-horizontal" }, React.createElement("ul", { className: "nav nav-tabs" }, stepSelectElements.map(function (element, index) {
	      return React.createElement(IntroStepSelectBlockElementSelector, _extends({ key: index, activeElementOrdinal: activeTabIndex, elementOrdinal: index + 1, selectElement: _this2.onElementSelect }, element));
	    })), React.createElement(FadingElementTabContentWrapper, { className: "tab-content", style: { borderTop: "1px solid #03a9f4" } }, stepSelectElements.map(function (element, index) {
	      return React.createElement(fading_element_1.default, { in: activeTabIndex == index + 1, key: index }, React.createElement("div", { className: activeTabIndex == index + 1 ? "tab-pane fade active in" : "tab-pane fade" }, React.createElement("h4", null, element.elementSelectorTitle), _this2.renderElementDescription(element.elementSelectorDescription)));
	    })))))));
	  };
	
	  return IntroStepSelectBlock;
	}(React.Component);
	/** STYLES */
	
	
	var IntroStepSelectBlockWrapper = styled_components_1.default.section(_templateObject);
	var FadingElementTabContentWrapper = styled_components_1.default.div(_templateObject2);
	var StyledSpan = styled_components_1.default.span(_templateObject3);
	var StyledLink = styled_components_1.default.a(_templateObject4);
	exports.default = IntroStepSelectBlock;

/***/ }),

/***/ 77:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var TicketSource = {
	    Aplikacja: 'Aplikacja',
	    BazaWiedzy: 'BazaWiedzy',
	    Czat: 'Czat',
	    BiuroRachunkowe: 'BiuroRachunkowe',
	    ZakladanieSpolek: 'ZakladanieSpolek',
	    Kontakt: 'Kontakt'
	};
	exports.TicketSource = TicketSource;

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_helmet_1 = __webpack_require__(23);
	var hero_text_on_left_block_1 = __webpack_require__(76);
	var title_block_1 = __webpack_require__(43);
	var intro_step_select_block_1 = __webpack_require__(135);
	var contact_form_block_1 = __webpack_require__(72);
	var faq_block_1 = __webpack_require__(75);
	var types_1 = __webpack_require__(14);
	var google_analytics_1 = __webpack_require__(34);
	var staticImages = __webpack_require__(38);
	var initialFormData = __webpack_require__(70);
	var freshworksData = __webpack_require__(71);
	var faqQuestionsData = __webpack_require__(69);
	var helmetData = __webpack_require__(21);
	var cacheBustingService = __webpack_require__(26);
	
	var ZakladanieSpolekZooPage = function (_React$Component) {
	    _inherits(ZakladanieSpolekZooPage, _React$Component);
	
	    function ZakladanieSpolekZooPage() {
	        _classCallCheck(this, ZakladanieSpolekZooPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    ZakladanieSpolekZooPage.prototype.componentDidMount = function componentDidMount() {
	        cacheBustingService.handleCacheBusting(caches);
	    };
	
	    ZakladanieSpolekZooPage.prototype.render = function render() {
	        return React.createElement("div", null, React.createElement(react_helmet_1.Helmet, _extends({}, helmetData.prepareHelmetData(types_1.PageType.ZakladanieSpolekZooPage))), React.createElement(hero_text_on_left_block_1.default, { title: "Zakładanie spółek online", description: ["Skorzystaj z naszej pomocy."], backgroundImage: staticImages.BUSINESS_HANDSHAKE_BACKGROUND_IMAGE, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooPageViewedMainTitleBlock }), React.createElement(title_block_1.default, { firstLineBlackStart: "Własna firma w formie spółki z o.o. w", firstLineBlue: "3 krokach", firstLineBlackEnd: "", secondLineText: "Skorzystaj z pomocy profesjonalistów, którzy specjalizują się w prawie handlowym.", paddingBottom: 0 }), React.createElement(intro_step_select_block_1.default, { stepSelectElements: [{
	                elementSelectorTitle: "DOSTĘPNE WARIANTY",
	                elementSelectorDescription: ["Wszystkie usługi przeprowadzania procedury rejestracji realizowane są przez profesjonalnych pełnomocników - adwokatów lub radców prawnych. Można wyróżnić dwie procedury rejestracji sp. z o.o.:", "a) online w systemie S24 przy pomocy uproszczonego wzorca Ministerstwa Sprawiedliwości oraz", "b) tradycyjnej przed notariuszem przez zawiązanie umowy szytej na miarę - trwałej na lata, gotowej na polski ład, przygotowanej przez profesjonalnego pełnomocnika."]
	            }, {
	                elementSelectorTitle: "SKONTAKTUJ SIĘ",
	                elementSelectorDescription: "Jeżeli chcesz przystąpić do dalszych działań lub jeżeli masz więcej pytań - skontaktuj się z nami. Uzyskasz informacje na temat dalszych czynności. Kontakt jest możliwy poprzez czat, infolinię oraz umieszczony poniżej formularz kontaktowy."
	            }, {
	                elementSelectorTitle: "ZAKŁADANIE SPÓŁKI",
	                elementSelectorDescription: "Ostatni etap zakładania spółki polega na przygotowaniu umowy, wniosku rejestracyjnego do KRS oraz pozostałych niezbędnych dokumentów. W każdej chwili mogą Państwo sprawdzić aktualny status sprawy, by dobrze rozplanować działania biznesowe. Po zawiązaniu umowy przed notariuszem lub uzyskaniu wpisu do KRS już nic nie stoi na przeszkodzie, by rozpocząć działalność gospodarczą."
	            }], componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooPageViewedStepSelectBlock, elementSelectEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooPageClickedStepSelectElement }), React.createElement(title_block_1.default, { id: 'kontakt', firstLineBlackStart: "Zainteresowany naszą", firstLineBlue: "ofertą", firstLineBlackEnd: "?", secondLineText: "Skontaktuj się w sprawie dalszych czynności.", paddingTop: 75, paddingBottom: 0 }), React.createElement(contact_form_block_1.default, { formInfo: initialFormData.ZakladanieSpolekZooPageFormInfo, iframeSourceUrl: freshworksData.ZAKLADANIE_SPOLEK_PAGE_FORM_IFRAME_SOURCE_URL }), React.createElement(title_block_1.default, { firstLineBlackStart: "Najczęściej zadawane", firstLineBlue: "pytania", firstLineBlackEnd: "", secondLineText: "Zapoznaj się z odpowiedziami na najczęściej zadawane pytania.", paddingTop: 100 }), React.createElement(faq_block_1.default, { faqQuestions: faqQuestionsData.ZAKLADANIE_SPOLEK_PAGE_FAQ_QUESTIONS, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooViewedFaqBlock, faqQuestionReadEventType: google_analytics_1.GoogleAnalyticsEventType.ZakladanieSpolekZooReadFaqQuestion }));
	    };
	
	    return ZakladanieSpolekZooPage;
	}(React.Component);
	
	exports.default = ZakladanieSpolekZooPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-zakladanie-spolek-zoo-tsx-19fdb2fa3a52d8253e92.js